import { MonoAvatarModule } from '../../../shared/directives/mono-avatar/mono-avatar.module';
import { PractitionerListComponent } from './practitioner-list.component';
import { TranslateModule } from '../../../shared/translate/translate.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { MatMenuModule, MatButtonModule } from '@angular/material';

@NgModule({
  declarations: [PractitionerListComponent],
  imports: [
    CommonModule,
    IonicModule,
    MonoAvatarModule,
    TranslateModule,
    MatMenuModule,
    MatButtonModule
  ],
  exports: [
    PractitionerListComponent
  ]
})
export class PractitionerListModule { }
